/**
 * Contador da multi-seleção do painel de Ações, com zero à esquerda ("02 itens selecionados").
 * Separado de `formatSelectedCount` de propósito: aquele alimenta o contador por seção da aba
 * Permissões, que o Figma mantém sem zero à esquerda.
 */
export function formatSelectionCount(count: number): string {
  return String(count).padStart(2, '0');
}
